import { monthsToIndexesWith0 } from '../../../Dashboards/Common/Util/getMonthsByYear';
import { useChartsDataContext } from './useChartsDataContext';

const useComparePerMonthPerYearTotalChart = () => {
    const { colors, subtitles, state, months } = useChartsDataContext();

    const series = subtitles.map((item, index) => {
        const data = months.map((month) => {
            const found = state.data.selectedYear.find(
                (counter) =>
                    counter.competency.slice(-2) === monthsToIndexesWith0[month]
            );

            return found
                ? index === 0
                    ? -found.debit_value
                    : found.credit_value
                : 0;
        });

        return {
            name: item,
            data
        };
    });

    const chartConfig = {
        series,
        options: {
            chart: {
                type: 'bar',
                height: 400,
                stacked: false,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false
                }
            },
            xaxis: {
                categories: months || []
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            fill: {
                opacity: 1
            },
            dataLabels: {
                enabled: true,
                formatter: function (val) {
                    if (val.toString().length > 5) {
                        return '';
                    }
                    return val;
                },
                style: {
                    fontSize: '11px'
                }
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        return val.toLocaleString('pt-BR');
                    }
                }
            },
            tooltip: {
                enabled: true,
                style: {
                    fontSize: '16px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Arial, sans-serif',
                    padding: '10px',
                    pointerEvents: 'auto',
                    zIndex: '1000'
                },
                y: {
                    formatter: (val) => (val ? val.toLocaleString('pt-BR') : '')
                }
            },
            colors: colors
        }
    };

    return {
        chartConfig
    };
};

export default useComparePerMonthPerYearTotalChart;
